/* eslint-disable no-nested-ternary */
import { Flex, FlexItem, Icon } from '@patternfly/react-core';
import { AngleDownIcon, AngleRightIcon } from '@patternfly/react-icons';
import ComponentError from 'components/Error/ComponentError';
import { observer } from 'mobx-react';
import React, { ReactElement, useState } from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { handleError } from 'services/ErrorService';
import { UserEntitlement } from 'types/user';
import './styles.scss';

type ExpandableSubscriptionWidgetProps = {
  entitlement: UserEntitlement;
  remainingEntitlementTime: number;
  remainingLabUsage: ReactElement;
};

const ExpandableSubscriptionWidget = ({
  entitlement,
  remainingEntitlementTime,
  remainingLabUsage,
}: ExpandableSubscriptionWidgetProps) => {
  const { t } = useTranslation();

  const [expanded, setExpanded] = useState(false);

  return (
    <div className="subscription-info">
      <Flex
        justifyContent={{ default: 'justifyContentSpaceBetween' }}
        alignItems={{ default: 'alignItemsCenter' }}
        flexWrap={{ default: 'nowrap' }}
        onClick={() => setExpanded(!expanded)}
      >
        <FlexItem>
          <strong>{entitlement.entitlement_info.title}</strong>
        </FlexItem>
        <FlexItem>
          <Icon size="lg">
            {expanded ? <AngleDownIcon /> : <AngleRightIcon />}
          </Icon>
        </FlexItem>
      </Flex>
      <div
        className={`subscription-info-details ${
          expanded ? 'subscription-info-details__expanded' : ''
        }`}
      >
        {entitlement.entitlement_info.modality === 'alacarte' &&
        remainingEntitlementTime > 0 &&
        remainingEntitlementTime <= 1 ? (
          <strong>{t('Last day')}</strong>
        ) : (
          <>
            {t('Days remaining')}&nbsp;
            <strong>{Math.round(remainingEntitlementTime)}</strong>
          </>
        )}
        {entitlement.quotas?.lab_hours && <div>{remainingLabUsage}</div>}
        {entitlement.quotas?.exams?.allowed > 0 && (
          <div>
            {t('Exams')}&nbsp;
            <strong>
              {entitlement.quotas.exams.used || 0}/
              {entitlement.quotas.exams.allowed}
            </strong>
          </div>
        )}
      </div>
    </div>
  );
};

export default withErrorBoundary(
  observer(ExpandableSubscriptionWidget),
  ComponentError,
  handleError,
);
